var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ev-ele-stat"},[_c('div',{staticStyle:{"width":"100%","cursor":"pointer"},on:{"click":_vm.handleNavGo}},[_c('pub-info-title',{attrs:{"title":'近30日光伏发电量统计'}})],1),_c('div',{staticClass:"content"},[_c('div',{ref:"evBar",attrs:{"id":"evBar"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }